import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import AuthForm from '@/components/AuthPage/AuthForm.vue'
import BenefitSection from '@/components/AuthPage/BenefitSection.vue'
import OceanNotice from '@/components/OceanNotice.vue'

import BgBottomLeft from '@/assets/bg-bottom-left.svg'
import BgBottomRight from '@/assets/bg-bottom-right.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthPage',
  props: {
    authType: null,
    redirectUrl: null
  },
  setup(__props: any) {

const props = __props as {
	authType: 'signin' | 'signup'
	redirectUrl: string
};


const currentAuthType = ref(props.authType)

watch(
	() => props.authType,
	(newType) => {
		currentAuthType.value = newType
	}
)

return { __sfc: true,props, currentAuthType, AuthForm, BenefitSection, OceanNotice, BgBottomLeft, BgBottomRight }
}

})